import type { ConnectorDefinition } from "../types";

/**
 * Databricks rides the Magnus login: its token is minted on behalf of the
 * signed-in user from their Microsoft refresh token (`getDatabricksOboToken`),
 * so there is no Connect step and no per-user connector row. Access is still
 * delegated, so Unity Catalog evaluates grants and row/column policies as the
 * real user. `connectors.databricks.enable` decides who gets it.
 */
export const databricksConnector: ConnectorDefinition = {
  id: "databricks",
  name: "Databricks",
  description:
    "Connect to Azure Databricks for data analytics, Unity Catalog, and SQL queries",
  icon: "databricks",
  authType: "system",
  system: {
    token: { from: "login", loginProvider: "microsoft" },
    // A minted token alone does not mean the user is in the workspace, so
    // "connected" has to be answered by resolving (and probing) it.
    resolvesToken: true,
  },
  isEnabled: () => Boolean(process.env.DATABRICKS_HOST),
};
